import styled from 'styled-components';
import { color } from '~/assets/styles/colors';

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	margin-top: 18px;
	margin-right: 18px;
	margin-left: 18px;
`;

export const BlockBotao = styled.button`
	display: flex;
	flex-direction: column;
	width: 100%;
	aspect-ratio: 1/1;
	background-color: ${color.white};
	justify-content: center;
	align-items: center;
	border: none;
	border-radius: 8px;
	box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

export const Circle = styled.div`
  display: flex;
  width: 13vw; /* Tamanho do círculo (ajuste conforme necessário) */
  height: 13vw; /* Tamanho do círculo (ajuste conforme necessário) */
  background-color: ${color.primary}; /* Cor do círculo */
  border-radius: 50%; /* Transforma em um círculo */
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
`;

export const ButtonListArea = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	margin-top: 18px;
`;

